/**
 * @generated SignedSource<<d12c0e2e7d68daf7b9a6c26182e84d5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountWelcome_user$data = {
  readonly account: {
    readonly account_type: string;
    readonly name: string;
  };
  readonly id: number;
  readonly viewed_welcome: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingDialog_user" | "WelcomeVideoDialog_user">;
  readonly " $fragmentType": "AccountWelcome_user";
};
export type AccountWelcome_user$key = {
  readonly " $data"?: AccountWelcome_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountWelcome_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "peopleFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectsFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountWelcome_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "account_type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewed_welcome",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WelcomeVideoDialog_user"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "peopleFilter",
          "variableName": "peopleFilter"
        },
        {
          "kind": "Variable",
          "name": "projectsFilter",
          "variableName": "projectsFilter"
        }
      ],
      "kind": "FragmentSpread",
      "name": "OnboardingDialog_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "54e73d7db6a7243b4040155811c92888";

export default node;
